import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">

        <p>
          © {new Date().getFullYear()} Scaffolders Education
        </p>

        <div className="footer-links">
          
          <Link to="/privacy-policy">
            Privacy Policy
          </Link>

          <Link to="/terms">
            Terms & Conditions
          </Link>

          <Link to="/refund-policy">
            Refund Policy
          </Link>

          

        </div>
      </div>
    </footer>
  );
}
